import { useState } from 'react'
import './SkillsInfoModal.css'
// import Button from '@mui/material/Button';
import original from "../../../assets/skillArnold/bodybuilder_Original.png";
import head from "../../../assets/skillArnold/bodybuilder_head.png";
import rightArm from "../../../assets/skillArnold/bodybuilder_rightArm.png";
import leftArm from "../../../assets/skillArnold/bodybuilder_leftArm.png";
import chest from "../../../assets/skillArnold/bodybuilder_chest.png";
import pack from "../../../assets/skillArnold/bodybuilder_pack.png";
import undi from "../../../assets/skillArnold/bodybuilder_undi.png";
import leg from "../../../assets/skillArnold/bodybuilder_leg.png";
import whole from "../../../assets/skillArnold/bodybuilding_whole.png";

const SkillsArnold = (props) => {
    const [selectedBodyPart, setSelectedBodyPart] = useState('original')
    const handleBodyPartClick = (e) => {
        // console.log('head clicked')
        // console.log(e.target.attributes.getNamedItem("data-skillPart").value);
        setSelectedBodyPart(
          e.target.attributes.getNamedItem("data-skillPart").value
        );
        props.setSkillTab(e.target.attributes.getNamedItem("data-skillPart").value);
    }
    return (
      <div className="skillsArnold-wrapper">
        <button
          className={`wholeBodySelect-btn ${
            selectedBodyPart === "whole" ? "wholeBodySelect-btn_selected" : null
          }`}
          onClick={() => {
            setSelectedBodyPart("whole");
            props.setSkillTab("whole");
          }}
        >
          Select whole body
        </button>
        {/* <p style={{ fontSize: "1.5vw" }}>
          <strong>Select my muscular body parts to see my skills</strong>
        </p> */}
        {/* <button onClick={() => props.setSkillTab(1)}>bt1</button>
        <button onClick={() => props.setSkillTab(2)}>bt2</button>
        <button onClick={() => props.setSkillTab(3)}>bt3</button> */}
        <div className="bodybuilder-img-wrapper">
          {/* <div className="svg-container">
            <svg
              // width="260"
              // height="547"
              // viewBox="0 0 260 547"
              viewBox="0 0 800 1000"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Head"
                d="M146.5 88L142.5 85.5L141 84.5L139 82.5L137 80.5L135 78L133.5 76L131.5 73.5L130 71L129 69L128 67L127 65L126 62.5L124.5 61L123.5 59V55.5L123 52V50L122.5 47.5L122 45.5V43.5L121.5 41.5L120.5 39.5L119 38.5L118 37L117 35.5L116 33.5L115.5 31.5V29V27.5L116 25.5L116.5 24L117.5 22.5L118 21L118.5 19L119 17.5L119.5 16L120.5 15L121 13.5L122 12.5L123 11L124.5 9L125.5 8L127.5 6.5L128.5 5L130 4.5L131.5 3.5L133.5 2.5L137 0.5H140.5H144.5H152H159.5L166 2.5L171 6.5C172.5 8.66667 175.5 13.1 175.5 13.5C175.5 13.9 177.5 18.6667 178.5 21L180.5 31V40V46.5L178.5 53V58.5L177 62L175.5 68L172.5 73L169.5 78.5L166 83L161 86.5L155 89.5H151L146.5 88Z"
                fill="blue"
                fill-opacity="0.39"
                // stroke="blue"
              />
              <path
                id="LeftArm"
                d="M206 99L213.5 95L217.5 96L220 97L224.5 99L228.5 101L232 103.5C233.167 104.5 235.6 106.5 236 106.5C236.4 106.5 238.167 109.167 239 110.5L242 116L244.5 121L247 126.5L249.5 132L251.5 137L253.5 142.5L255.5 148V154.5L256 162V168V175V179.5L257 183.5L258 187L258.5 193.5L258 200V205.5L257 211.5L255.5 218L254.5 225L253 230.5L251 236.5L248.5 241.5L245.5 249.5L243 255L241 259V262.5L240 266L237.5 268L235 271.5V275L234 279.5L232.5 284L230.5 287.5L228 291.5L225 294L220.5 295.5H215.5H211L204.5 294.5H201.5L200.5 290L200 285V282.5L201.5 279.5L203 276.5L205 273L207.5 270.5L211 267L214.5 264.5L217.5 262.5L220.5 261L223 258L224.5 256L226 253L228 248.5L228.5 241.5V235.5L228 230.5V225V217.5L229 208L230 201.5L231.5 193V185L226.5 183L221 179.5L215 173L211 165L207.5 157L206 146V139V132L203 128.5L201 121V111.5V104.5L206 99Z"
                fill="#E72626"
                fill-opacity="0.35"
                // stroke="blue"
              />
              <path
                id="Leg"
                d="M141 278.5L139 283.5H138.5L135.5 281L131 277L126 273L122 269L116 263L111 258L105 254L100.5 251.5L96.5 249L96 250L94 254.5L92.5 259.5L89.5 266.5L88 273L86.5 280.5L84.5 287L83.5 295L81 302L80 310V316.5V323L81 331.5V337.5L82.5 346.5L83.5 353.5L84.5 358.5C85.5 360.5 87.6 364.6 88 365C88.5 365.5 90.5 370.5 91 371C91.4 371.4 92.1667 373.5 92.5 374.5V380.5C92.5 381.3 93.1667 384.5 93.5 386L94 390.5L95.5 395C96 396.167 97 398.8 97 400C97 401.2 98 403.833 98.5 405L100 409.5V416L101.5 421V426.5L102.5 431L103.5 436L105 441.5L107 446.5L108.5 452L111 456.5L114 464L117.5 471.5L119.5 481L122 488.5L124 494.5L124.5 500L125 506.5L124.5 513L122 516L117.5 520L112 524L108.5 527L104 528.5L100 530.5L96 533.5H92.5L89 534.5L88 537.5L86.5 539.5V542L89 543L96 542L101 540.5L111 539.5L119.5 537.5H129L135 536.5H143.5H149.5L154.5 535.5L156 529.5L152 518.5L149.5 507L146 493L145 483L143.5 471.5V460L145 451L146 445.5V435L143.5 425.5L137.5 413L133 405L128 398.5V393V385.5L129.5 377.5L131.5 368L134 358.5L137.5 350.5L139.5 344L142 337.5L144 331.5L145.5 328L148.5 326C149.333 327 151.1 329.2 151.5 330L153.5 334L155.5 340V346.5L157 353.5L158.5 362.5L161.5 369.5L164.5 376L167 382L169.5 389.5L171.5 396L173.5 400L177.5 407L179 413L181 418.5V423.5L179 428L177.5 435V441.5L179 446.5C179.5 447.667 180.6 450.2 181 451C181.5 452 183 455 183.5 455.5C184 456 185 458.5 185.5 460C185.9 461.2 187.333 463.167 188 464L189 468.5L190.5 473.5L192.5 481L194.5 488.5L197 495L198 500V505.5V510.5V515V520V525L199 529.5L200.5 533.5L201.5 536.5L203.5 539.5L206 543L208.5 545H212.5L217 546L221.5 545H228H233L236 543L237.5 542V539.5L233 535.5L226.5 530.5L221.5 525L217 520L216 514V503.5V491.5L217 481V470.5L218 460L219 451V443.5V432L218 423.5L214.5 415L209.5 405L204.5 396L203 387.5L202 376L203 336L201.5 304L200.5 293L198.5 283.5L197.5 278.5L196 271L194.5 264L193 256.5L191 251L189 250L184 249L178 250L173.5 251L166.5 253.5L161.5 255.5L157.5 259.5L151.5 263L146.5 268.5L143.5 273L141 278.5Z"
                fill="#B03333"
                fill-opacity="0.37"
                // stroke="blue"
              />
              <path
                id="Pack"
                d="M147 148H141H137L131 150L124.5 151.5L113.5 153L102.5 151.5H95L97 154L101 160L104 168.5L109.5 180L108 189L104 201L102.5 211V221.5L101 230L107 231L115.5 233L126.5 234L148.5 233L165.5 231L183 227L194.5 225.5L192 221.5L190.5 215V208.5L192 206L194.5 201L198.5 195.5L205 189L211 184L217 178L213 170.5L207 157L205 145L198.5 146L188 148L179.5 150H169.5L160.5 148H152H147Z"
                fill="#B32D2D"
                fill-opacity="0.52"
                // stroke="blue"
              />
              <path
                id="RightArm"
                d="M88.5 93L89.5 86L86 87.5L82.5 88L79 89L76.5 89.5L72.5 91L70 89.5L67 87.5L65 85.5L62 84L59 82H55H52L50.5 84L48 86L46 87.5L43.5 89.5L42.5 91H40.5L39 92H37.5L38.5 89.5L39 86L40.5 84L41.5 80V75.5V71.5L42 66V62V57.5L42.5 53.5L43.5 50.5V47.5L45 46L46.5 46.5L48 48.5L50.5 49.5H54L57.5 50.5H61H64.5L67 49.5L69 48.5L71 46.5L72.5 44V40.5V35.5V32L71 28.5L69 27L64.5 25L60.5 24L55 23L50.5 22H46.5L42 23L39 24L36 27L34 31.5L32.5 35.5L29 42.5L24 51.5L18.5 59L14 65L10 71L6.5 76.5L4.5 81.5L3.5 88L2 95L0.5 99V105L3.5 110.5L10 115L18.5 120L27.5 125.5L36 130L44.5 134L51.5 135H59.5H66.5L76 133H83L83.5 130.5L86 118V109L87.5 99L88.5 93Z"
                fill="#EA1F1F"
                fill-opacity="0.37"
                // stroke="blue"
              />
              <path
                id="Chest"
                d="M88 100.5L90.5 85.5L95 86.5H99H103.5L108 88.5L113.5 90.5L118 93H122.5L127.5 90.5L132.5 88.5L136 85.5L138 83.5L140 85.5L143 87.5L146.5 89.5L152 90.5L156.5 88.5L161 86.5L166 83.5L169.5 80L172 76L173.5 73L175 71.5L177 74L179.5 76L182.5 80L185.5 82.5L191.5 83.5L197 85.5L202 88.5L207.5 90.5L212.5 94.5L208.5 96.5L204 99.5L200 104V110.5V120.5L202 127L206 132L205 137V145.5H201L188.5 148.5L175 150.5L162 147.5H146.5H137L124.5 150.5L109.5 152L94 150.5L83.5 133L86 118L88 100.5Z"
                fill="#E31D1D"
                fill-opacity="0.42"
                // stroke="white"
              />
              <path
                id="Undi"
                d="M97 248.5L100.5 230.5H108L115 232L120.5 233.5H126.5H133H138.5H144.5H151.5H155L162 232L167.5 230.5L172 229L179 227L184 226H188.5H193V228V232V238V243L191.5 247.5V252L190.5 250.5L187 249.5H182.5L179 250.5L172 252L165.5 254L160.5 257L155 261L149.5 265L145.5 269L141.5 277L138.5 283.5L133 278.5L125 272L116.5 263.5L109.5 257L103 252L97 248.5Z"
                fill="#DB3636"
                fill-opacity="0.33"
                // stroke="orange"
              />
            </svg>
            </div>
           */}
          {/* <img src={original} className="bodybuilder-img" /> */}
          <img src={original} useMap="#image-map" className="bodybuilder-img" /> 
           {selectedBodyPart === "original" ? (
            <img
              src={original}
              useMap="#image-map"
              className="bodybuilder-img"
            />
          ) : null}
          {selectedBodyPart === "whole" ? (
            <img src={whole} useMap="#image-map" className="bodybuilder-img" />
          ) : null}
          {selectedBodyPart === "rightArm" ? (
            <img
              src={rightArm}
              useMap="#image-map"
              className="bodybuilder-img"
            />
          ) : null}
          {selectedBodyPart === "leftArm" ? (
            <img
              src={leftArm}
              useMap="#image-map"
              className="bodybuilder-img"
            />
          ) : null}
          {selectedBodyPart === "chest" ? (
            <img src={chest} useMap="#image-map" className="bodybuilder-img" />
          ) : null}
          {selectedBodyPart === "head" ? (
            <img src={head} useMap="#image-map" className="bodybuilder-img" />
          ) : null}
          {selectedBodyPart === "pack" ? (
            <img src={pack} useMap="#image-map" className="bodybuilder-img" />
          ) : null}
          {selectedBodyPart === "undi" ? (
            <img src={undi} useMap="#image-map" className="bodybuilder-img" />
          ) : null}
          {selectedBodyPart === "leg" ? (
            <img src={leg} useMap="#image-map" className="bodybuilder-img" />
          ) : null}
          <map name="image-map">
            <area
              target
              alt="headaa"
              title="Programming Skills"
              data-skillPart="head"
              onClick={handleBodyPartClick}
              href
              coords="220,93,226,82,229,71,231,59,232,43,228,32,224,23,218,17,209,15,199,14,189,15,180,19,173,25,169,34,167,43,170,51,173,55,173,61,175,68,178,76,182,83,186,89,190,95,197,100,204,101,211,101"
              shape="poly"
            />
            <area
              target
              alt="rightArm"
              title="Front End Dev Skills"
              data-skillPart="rightArm"
              onClick={handleBodyPartClick}
              href
              coords="139,100,137,111,137,122,136,129,135,139,134,145,123,148,110,148,97,146,85,142,75,137,64,130,56,123,53,117,54,108,56,100,58,91,62,83,68,77,74,68,80,59,85,49,88,41,94,37,102,37,111,38,121,41,124,50,123,59,116,63,107,63,101,61,96,58,94,65,93,74,93,82,91,91,90,99,88,106,95,104,101,98,108,96,117,101,121,104,127,106"
              shape="poly"
            />
            <area
              target
              alt="leftArm"
              title="Back End Dev Skills"
              data-skillPart="leftArm"
              onClick={handleBodyPartClick}
              href
              coords="266,109,259,116,254,124,253,134,256,141,260,147,258,155,258,164,261,173,265,182,271,190,278,195,283,199,284,207,282,220,280,230,280,244,280,254,279,263,274,271,266,278,258,285,253,293,252,302,257,308,266,309,274,308,281,303,284,295,286,286,290,281,293,273,297,263,302,251,307,235,309,220,310,204,308,192,308,173,307,161,301,146,295,135,290,124,283,116,273,111"
              shape="poly"
            />
            <area
              target
              alt="chest"
              title="Database Skills"
              data-skillPart="chest"
              onClick={handleBodyPartClick}
              href
              coords="135,146,137,151,140,158,145,164,149,168,157,166,164,166,169,165,178,164,185,162,190,159,199,161,206,163,216,164,227,165,238,164,244,163,251,159,257,155,257,147,252,137,251,126,254,118,259,110,254,104,246,101,239,98,232,92,225,89,215,100,206,104,197,103,190,100,182,104,170,108,161,105,150,102,143,101,139,109,137,125,135,137"
              shape="poly"
            />
            <area
              target
              alt="pack"
              title="Web Dev Helping Tools"
              data-skillPart="pack"
              onClick={handleBodyPartClick}
              href
              coords="150,169,157,167,165,167,173,166,184,163,190,161,201,163,215,165,224,166,234,166,246,168,252,171,258,177,262,184,266,190,261,197,256,203,249,210,243,218,243,229,243,238,234,241,224,242,213,244,200,245,189,245,180,246,168,246,159,244,155,237,155,224,156,215,158,207,160,200,160,192,157,184,152,178"
              shape="poly"
            />
            <area
              target
              alt="undi"
              title="Forbidden Part"
              data-skillPart="undi"
              onClick={handleBodyPartClick}
              href
              coords="152,244,161,247,170,248,181,248,191,249,204,248,219,246,228,244,239,241,244,240,245,249,244,258,243,266,233,263,225,264,216,267,208,272,200,279,196,285,192,292,189,298,182,291,176,284,169,279,161,271,155,266,149,262,150,253"
              shape="poly"
            />
            <area
              target
              alt="leg"
              title="Other Skills"
              data-skillPart="leg"
              onClick={handleBodyPartClick}
              href
              coords="191,297,196,287,201,279,208,272,217,266,227,264,234,264,243,266,245,274,247,284,248,292,251,302,252,313,253,329,253,346,253,363,253,383,253,402,260,414,264,423,268,433,270,446,270,461,269,474,268,489,268,503,268,515,268,527,271,535,278,543,284,549,289,553,283,558,274,559,264,558,257,554,251,545,250,535,249,527,249,515,246,503,244,491,242,481,237,469,231,461,229,452,230,444,230,433,231,426,226,414,222,405,218,394,216,385,211,378,208,365,206,356,205,347,203,341,198,336,197,343,193,350,190,358,186,370,182,382,180,396,179,410,185,421,190,428,196,438,199,451,197,461,196,472,196,483,197,495,199,507,202,520,205,533,208,543,205,550,195,549,181,550,167,552,151,554,140,555,144,547,150,545,158,541,166,537,173,530,177,524,176,510,171,499,168,485,163,472,158,455,154,439,151,420,146,403,144,387,138,372,134,352,131,337,134,322,137,305,141,288,144,277,147,264,161,273,175,286,183,293"
              shape="poly"
            />
          </map>
        </div>
      </div>
    );
}

export default SkillsArnold;